<template>
  <div class="add_on-header">
    <div class="d-flex align-items-center">
      <span class="material-symbols-outlined add_on-icon">
        {{ props.addOnDetails.addOnIconCode }}
      </span>
      <h2 class="add_on-title">{{ props.addOnDetails.addOnName }}</h2>
    </div>
    <p class="add_on-subtitle m-0">
      {{
        t("ADD_ONS.POWERED_BY", { provider: props.addOnDetails.addOnProvider })
      }}
    </p>
  </div>
  <div class="add_on-details mb-2_5">
    <p class="m-0 px-3 add_on-accent-subtitle">
      {{ t("ADD_ONS.PAYMENT_PLAN") }}
    </p>
    <div>
      <p class="d-flex justify-content-between m-0 px-3 mb-2">
        <span class="base-text">
          {{ props.addOnDetails.addOnWeeksPayment }}
          {{ t("ADD_ONS.WEEKLY_PAYMENTS") }}
        </span>
        <span class="base-text bold">
          ${{ props.addOnDetails.addOnWeeklyPayment }}
        </span>
      </p>
    </div>
    <div>
      <p class="m-0 px-3 py-2 add_on-accent-subtitle">
        {{ t("ADD_ONS.COVERAGE") }}
      </p>
      <div
        class="base-text ps-3 pe-2"
        v-html="
          t(`ADD_ONS.${props.addOnDetails.addOnDescriptionTranslationKey}`)
        "
      ></div>
    </div>
    <div class="p-3 add_on-acceptance-terms">
      <p class="m-0 text-center">
        <a
          :href="props.addOnDetails.addOnTermsAndConditionsUrl"
          @click="handleTermsAndConditionsClick"
          target="_blank"
        >
          {{ t("ADD_ONS.SEE_TERMS_CONDITIONS") }}
        </a>
      </p>
    </div>
  </div>
  <div
    class="add_on-alert-savings d-flex px-2 py-1 justify-content-center align-items-center"
  >
    <div>
      <span class="material-symbols-outlined alert-icon"> trending_down </span>
    </div>
    <div>
      <p class="m-0">
        {{
          t("ADD_ONS.PAY_MORE_SAVINGS", {
            amount: props.addOnDetails.addOnWeeklyPayment,
          })
        }}
      </p>
    </div>
  </div>
</template>

<script setup lang="ts">
import { IAddOnDetailsResponse } from "@/apps/credit-line/types/responses";
import { useI18n } from "@/apps/credit-line/composables/useI18n";
import logAnalyticsEvent from "@/apps/credit-line/services/google-analytics-events.service";
import AnalyticEvents from "@/shared-helpers/google-analytics-events.helper";

const { t } = useI18n();
const props = defineProps<{
  addOnDetails: IAddOnDetailsResponse;
}>();

const handleTermsAndConditionsClick = () => {
  logAnalyticsEvent(
    AnalyticEvents.CreditLine.AddOnTermsAndConditionsClicked,
    "AddOns",
    undefined,
    {
      cartAddOnId: props.addOnDetails.cartAddOnId,
      addOnName: props.addOnDetails.addOnName,
      termsUrl: props.addOnDetails.addOnTermsAndConditionsUrl,
    }
  );
};
</script>

<style scoped lang="scss">
@import "@/assets/scss/_constants.scss";
.add_on-header {
  margin-bottom: 0.875rem;
}
.add_on-icon {
  font-size: 2rem;
  color: #007c3b;
}
.alert-icon {
  font-size: 1.5rem;
  color: #007c3b;
}
.add_on-title {
  font-size: 1.25rem;
  font-weight: 600;
  font-family: Inter;
  line-height: 1.375rem;
  margin-left: 0.625rem;
  margin-bottom: 0;
  color: #111;
}
.add_on-subtitle {
  font-size: 0.813rem;
  font-weight: 400;
  font-family: Inter;
  line-height: 1.625rem;
  color: $pj-color-sub-gray;
}

.add_on-details {
  width: 100%;
  border: 1px solid #d1d1d1;
  border-radius: 5px;
}

.add_on-alert-savings {
  width: 100%;
  background: #e6f4ea;
  border-radius: 5px;
  gap: 0.5rem;
  margin-top: 0.875rem;

  p {
    font-family: Inter;
    font-size: 0.75rem;
    font-weight: 400;
    color: #007c3b;
    line-height: 1rem;
  }
}

.add_on-accent-subtitle {
  color: $pj-color-black111;
  font-weight: 600;
  line-height: 1rem;
  font-size: 1rem;
  font-family: Inter;
  padding-top: 0.625rem;
  padding-bottom: 0.625rem;
}
.base-text {
  color: black;
  font-weight: 400;
  font-size: 0.875rem;
  font-family: Inter;

  &.bold {
    font-weight: 500;
  }
}
.add_on-acceptance-terms {
  border-top: 1px solid #d1d1d1;
  p {
    color: #007c3b;
    font-size: 0.875rem;
    line-height: 0.875rem;
    a {
      color: #007c3b;
      text-decoration: none;
    }
  }
}
</style>
